import { render } from "./avatarMenu.vue?vue&type=template&id=6c7b9c7a&scoped=true"
import script from "./avatarMenu.vue?vue&type=script&lang=js"
export * from "./avatarMenu.vue?vue&type=script&lang=js"

import "./avatarMenu.vue?vue&type=style&index=0&id=6c7b9c7a&lang=scss&scoped=true"
import "./avatarMenu.vue?vue&type=style&index=1&id=6c7b9c7a&lang=scss"

import exportComponent from "D:\\客云\\newQsProject\\qs3_pc_portal\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c7b9c7a"]])

export default __exports__